import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from "../components/AutoPart/HeroSection"; // Updated path
import TestimonialsSection from "../components/TestimonialsSection";
import CallToAction from "../components/AutoPart/CallToAction"; // Updated path
import FeaturesSection from "../components/AutoPart/FeaturesSection"; // Updated path
import PricingPage from "./PricingPage";

const AutoPartLandingPage = () => {
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'page_type': 'auto_part_landing',
            'industry': 'auto_part'
        });
    }, []);

    return (
        <>
            <Helmet>
                <title>GarageHero - Sistema para Auto Peças</title>
                <meta name="description"
                      content="Sistema completo para gestão de auto peças. Organize serviços, controle financeiro e conquiste mais clientes com o GarageHero." />
                <meta property="og:title" content="GarageHero - Sistema para Auto Peças" />
                <meta property="og:description"
                      content="Sistema completo para gestão de auto peças. Organize serviços, controle financeiro e conquiste mais clientes com o GarageHero." />
                <meta property="og:url" content="https://auto-pecas.garagehero.com" />
                <meta name="keywords"
                      content="sistema auto peças, gestão auto peças, software auto peças, agendamento auto peças, gestão serviços automotivos, controle financeiro automotivo" />
            </Helmet>
            <HeroSection />
            <FeaturesSection />
            <TestimonialsSection />
            <PricingPage />
            <CallToAction />
        </>
    );
};

export default AutoPartLandingPage;
